import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@mui/material'

interface FileAccordionProps {
    header: React.ReactNode,
    children?: React.ReactNode,
    append?: React.ReactNode,
    expanded?: boolean,
}

export default function FileAccordion({ header, children, append, expanded = false }: Readonly<FileAccordionProps>) {
    const [active, setActive] = useState(expanded)
    return <div className="custom-accordion file" >
        <div className={`custom-accordion-header`} style={{ padding: '0 1rem' }}>
            <Button
                onClick={() => setActive(exp => !exp)}
                style={{ padding: 0, textTransform: 'none' }}
                variant='text'
                color='inherit'
                startIcon={<FontAwesomeIcon icon={active ? 'folder-open' : 'folder-closed'} />}
            >
                <u> {header}</u>
            </Button>
            {append}
        </div>
        <div className={`custom-accordion-content ${active && 'expanded'}`}>{children}</div>
    </div>
}